"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAssignation = void 0;
class SimpleAssignation {
    assignationId;
    userId;
    vehicleId;
    vehicleType;
    acceptationNote;
    driverName;
    vehicleName;
    status;
    statusAt;
}
exports.SimpleAssignation = SimpleAssignation;
//# sourceMappingURL=SimpleAssignation.js.map